import React, { createContext, useContext, useReducer } from "react";
import {
    testWorkflowReducer,
    INITIAL_TEST_WORKFLOW_STATE
} from "../constants/testWorkflowState";

const AppWorkflowContext = createContext(null);

export const AppWorkflowProvider = ({ children }) => {
    const [workflowState, dispatchWorkflow] = useReducer(
        testWorkflowReducer,
        INITIAL_TEST_WORKFLOW_STATE
    );

    const contextValue = {
        workflowState,
        dispatchWorkflow,
    };

    return (
        <AppWorkflowContext.Provider value={contextValue}>
            {children}
        </AppWorkflowContext.Provider>
    );
};

export const useAppWorkflowContext = () => {
    const context = useContext(AppWorkflowContext);
    if (!context) {
        throw new Error("useAppWorkflowContext must be used within AppWorkflowProvider");
    }
    return context;
};